module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back page-step5"
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("确认订单")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "报名场次",
      "value": _vm.row._saiqu.name || '—',
      "input-align": "right"
    }
  }), _vm._v(" "), _vm._l((_vm.row.list), function(item, index) {
    return _c('van-cell', {
      key: index,
      attrs: {
        "input-align": "right",
        "title": item.service_name,
        "value": '¥' + item.price + ' x ' + item.count
      }
    })
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "费用总计",
      "value": '¥' + (_vm.row.order.total || 0),
      "input-align": "right"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": "",
      "native-type": "button"
    },
    on: {
      "click": _vm.goPre
    }
  }, [_vm._v("上一步\n      ")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "native-type": "submit",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    }
  }, [_vm._v("确定提交\n      ")])], 1)], 1), _vm._v(" "), _c('van-popup', {
    style: ({
      maxHeight: '88%',
      paddingBottom: 'env(safe-area-inset-bottom)'
    }),
    attrs: {
      "position": "bottom",
      "round": "",
      "closeable": "",
      "close-icon-position": "top-right"
    },
    model: {
      value: (_vm.offlinePayQrShow),
      callback: function($$v) {
        _vm.offlinePayQrShow = $$v
      },
      expression: "offlinePayQrShow"
    }
  }, [_c('div', {
    staticClass: "offline-pay-popup"
  }, [_c('div', {
    staticClass: "offline-pay-popup__title"
  }, [_vm._v("线下付款请扫码")]), _vm._v(" "), _vm._l((_vm.payQrcodeList), function(pic, idx) {
    return _c('div', {
      key: idx,
      staticClass: "offline-pay-popup__img-wrap"
    }, [_c('img', {
      staticClass: "offline-pay-popup__img",
      attrs: {
        "src": pic.url,
        "alt": "付款二维码"
      }
    })])
  }), _vm._v(" "), (_vm.payQrcodeList.length === 0) ? _c('div', {
    staticClass: "offline-pay-popup__empty"
  }, [_vm._v("暂无收款二维码")]) : _vm._e(), _vm._v(" "), _c('van-button', {
    staticClass: "offline-pay-popup__btn",
    attrs: {
      "block": "",
      "round": "",
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
    },
    on: {
      "click": _vm.goOfflinePayUpload
    }
  }, [_vm._v("上传汇款凭证")])], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa9dab20","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/skill/AbilityApplyStep5.vue
// module id = 2640
// module chunks = 0